import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X, Leaf, ArrowRight } from "lucide-react";

const POPUP_IMG =
  "https://customer-assets-lxgj4vgw.emergentagent.net/job_dolce-portfolio/artifacts/8cff98e21f81ca49_gpt-image-2.5-flare_devi_mettere_al_posto_della_torta_del_cappuccino_della_brioche_e_della_spremuta_-1.webp";

const STORAGE_KEY = "psv-announce-autunno-v1";

export const AnnouncementPopup = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (localStorage.getItem(STORAGE_KEY)) return;
    const t = setTimeout(() => setOpen(true), 1400);
    return () => clearTimeout(t);
  }, []);

  const close = () => {
    localStorage.setItem(STORAGE_KEY, "1");
    setOpen(false);
  };

  const goToGusti = () => {
    close();
    setTimeout(() => {
      if (window.__lenis) {
        window.__lenis.scrollTo("#gusti", { offset: -70 });
      } else {
        document.querySelector("#gusti")?.scrollIntoView({ behavior: "smooth" });
      }
    }, 400);
  };

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.35 }}
          className="fixed inset-0 z-[80] bg-black/45 backdrop-blur-sm flex items-center justify-center p-5"
          onClick={close}
          data-testid="announcement-popup"
          role="dialog"
          aria-modal="true"
          aria-label="Novità autunnali: Briosé in 10 gusti"
        >
          <motion.div
            initial={{ opacity: 0, y: 44, scale: 0.95 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 30, scale: 0.96 }}
            transition={{ duration: 0.55, ease: [0.22, 1, 0.36, 1] }}
            className="relative bg-[#fbf6f1] rounded-3xl overflow-hidden max-w-md w-full border border-[#e6dacb] shadow-2xl shadow-black/25"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={close}
              data-testid="popup-close-button"
              aria-label="Chiudi annuncio"
              className="absolute top-4 right-4 z-10 w-10 h-10 rounded-full bg-[#fbf6f1]/90 text-black flex items-center justify-center hover:bg-[#84232a] hover:text-[#fbf6f1] transition-colors duration-300"
            >
              <X className="w-5 h-5" />
            </button>

            <img
              src={POPUP_IMG}
              alt="Le Briosé nei dieci gusti su alzatine"
              className="w-full h-44 sm:h-52 object-cover"
              data-testid="popup-image"
            />

            <div className="p-7 sm:p-8">
              <p className="flex items-center gap-2.5 text-[0.7rem] uppercase tracking-[0.3em] font-semibold text-[#84232a]">
                <Leaf className="w-4 h-4" />
                Novità Autunnali
              </p>
              <h2
                className="font-display text-3xl sm:text-4xl font-semibold text-black mt-3"
                data-testid="popup-title"
              >
                Briosé — 10 gusti
              </h2>
              <p className="text-[#4a423d] text-sm sm:text-base leading-relaxed mt-3">
                Brioche tonde, soffici e a lenta lievitazione, con un cuore tutto da
                scoprire. Dieci gusti irresistibili che stanno già conquistando tutti
                al primo morso.
              </p>
              <button
                onClick={goToGusti}
                data-testid="popup-cta-scopri"
                className="group mt-6 inline-flex items-center gap-3 bg-[#84232a] text-[#fbf6f1] px-7 py-3.5 rounded-full text-sm font-medium hover:bg-[#63191f] transition-colors duration-300"
              >
                Scopri di più
                <ArrowRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1" />
              </button>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
